import React from 'react';
import '../style/SearchResponse.css';
import ResultItem from '../items/ResultItem';

function SearchResponse({ announcements }) {
    if (!announcements || announcements.length === 0) {
        return null;
    }

    // Ограничиваем до 10 результатов
    const limitedAnnouncements = announcements.slice(0, 10);

    return (
        <div className="search_response_section grid grid-cols-2 gap-3">
            {limitedAnnouncements.map((announcement, index) => (
                <ResultItem 
                    key={announcement.id || index}
                    title={announcement.title} 
                    categoryName={announcement.category} 
                    subCategoryName={announcement.subCategory} 
                    categoryId={announcement.categoryId} 
                    subCategoryId={announcement.subCategoryId} 
                    location={announcement.location?.locality || announcement.location?.province || ''}
                />
            ))}
        </div>
    );
}

export default SearchResponse;